export default function SectionTitle({ title }) {
  return (
    <div className="d-flex w-100 flex-column align-items-center gap-1">
      <p className="fs-1 fw-bold text-primary p-0 m-0">{title}</p>
      <hr className="w-100" />
    </div>
  );
}
